import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button, ButtonGroup } from '@mui/material';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <ButtonGroup variant="outlined" size="small">
      <Button
        onClick={() => setLanguage('en')}
        variant={language === 'en' ? 'contained' : 'outlined'}
      >
        EN
      </Button>
      <Button
        onClick={() => setLanguage('he')}
        variant={language === 'he' ? 'contained' : 'outlined'}
      >
        HE
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSwitcher; 